import { RestFeedSummary } from "../schema-copy/api-schema";
import { getFeedSummaries } from "./api";
import { AuthData } from "./auth";

// Session-wide cache for feed summaries (tiny objects, no eviction needed).
// null marks ids the server didn't return, so they aren't re-requested.
const cache = new Map<string, RestFeedSummary | null>();
// Ids with a request on the wire share one promise, so concurrent callers
// (e.g. StrictMode's double effect run, or sibling FeedTiles) don't re-fetch.
const inFlight = new Map<string, Promise<void>>();

export async function getCachedFeedSummaries(auth: AuthData, feedIds: string[]): Promise<RestFeedSummary[]> {
    const ids = Array.from(new Set(feedIds));
    const toFetch = ids.filter(id => !cache.has(id) && !inFlight.has(id));
    if (toFetch.length) {
        const request = getFeedSummaries(auth, toFetch)
            .then(summaries => {
                for (const s of summaries) cache.set(s.id, s);
                for (const id of toFetch) if (!cache.has(id)) cache.set(id, null);
            })
            .finally(() => toFetch.forEach(id => inFlight.delete(id)));
        for (const id of toFetch) inFlight.set(id, request);
    }
    await Promise.all(ids.map(id => inFlight.get(id)).filter(Boolean));
    return ids.map(id => cache.get(id)).filter((s): s is RestFeedSummary => !!s);
}
